import { subject } from "@casl/ability";
import { Can } from "@dashboard/casl/taskAbility";
import { Button } from "frontend-components";
import { useTranslation } from "react-i18next";
import type { ListRow } from "./utils";

type TemplateCardProps = {
    list: ListRow;
    onOpen: (listId: number) => void;
    onUse: (listId: number) => void;
};

export default function TemplateCard({ list, onOpen, onUse }: TemplateCardProps) {
    const { i18n, t } = useTranslation();
    return (
        <li className="rounded-[3px] border border-compendia-border bg-compendia-card px-3 py-3 transition-colors hover:bg-compendia-greige-20 sm:px-4">
            <button
                type="button"
                onClick={() => onOpen(list.id)}
                className="w-full cursor-pointer text-left text-base font-medium text-compendia-foreground line-clamp-2 wrap-break-word hover:underline"
            >
                {list.title}
            </button>

            <div className="mt-3 flex items-center justify-between gap-3">
                <span className="text-label text-compendia-muted">
                    {t("common.tasks")}: {list.totalTasks} ·{" "}
                    {new Date(list.updatedAt).toLocaleDateString(i18n.language)}
                </span>
                <Can I="create" this={subject("TaskList", { instanceId: list.instanceId })}>
                    <Button
                        type="button"
                        className="shrink-0 px-4 py-1.5 text-sm"
                        onClick={() => onUse(list.id)}
                    >
                        {t("list.useTemplate")}
                    </Button>
                </Can>
            </div>
        </li>
    );
}
